import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FC, ReactNode, useState } from "react";

type IProps = {
  children: ReactNode;
};

const ReactQueryProvider: FC<IProps> = ({ children }) => {
  const MINUTE = 1000 * 60;

  const [queryClient] = useState(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: 1,
          gcTime: MINUTE * 30,
          staleTime: MINUTE * 30,
          refetchInterval: MINUTE * 30,
          refetchOnMount: false,
          refetchOnWindowFocus: false,
          refetchIntervalInBackground: false,
        },
      },
    });
  });

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools position='top-right' initialIsOpen={true} /> */}
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
